import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";

const faqs = [
  {
    q: "Is this a template or actually custom?",
    a: "Fully custom. We build your AI from scratch based on your business, your voice, and your qualification process. No two builds are the same.",
  },
  {
    q: "How long does setup take?",
    a: "3 to 7 days from the time you complete the onboarding questionnaire.",
  },
  {
    q: "Do I need any technical skills?",
    a: "None. We handle everything. You fill out a questionnaire, we build it, you approve it, it goes live.",
  },
  {
    q: "How is this different from tools like Appointwise?",
    a: "Tools like Appointwise are self-serve platforms — you sign up, configure it yourself, and work from templates. AppoinText is a done-for-you build. We study your business, write your AI's conversation flows from scratch, and hand you a finished product. There's no setup headache because we do the setup.",
  },
  {
    q: "How is pricing structured?",
    a: "Pricing is based on your setup. Book a free call and we'll give you a straight answer in 15 minutes.",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32 relative scroll-mt-24">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mb-12 md:mb-14"
        >
          <h2
            data-testid="faq-heading"
            className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white tracking-tight"
            style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
          >
            Questions? We've got answers.
          </h2>
        </motion.div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.3, delay: i * 0.05 }}
              data-testid={`faq-item-${i}`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between text-left bg-zinc-900/50 hover:bg-zinc-900/80 border border-white/5 rounded-xl px-6 py-4 transition-colors group"
                data-testid={`faq-toggle-${i}`}
              >
                <span className="text-white text-sm font-medium pr-4">{faq.q}</span>
                <ChevronDown
                  size={18}
                  className={`text-zinc-400 shrink-0 transition-transform duration-300 ${
                    openIndex === i ? "rotate-180" : ""
                  }`}
                />
              </button>
              <AnimatePresence>
                {openIndex === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.25 }}
                    className="overflow-hidden"
                  >
                    <div className="px-6 py-4 text-zinc-400 text-sm leading-relaxed">
                      {faq.a}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
